// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { Page403Component } from '@med/app/errors/components/page-403/page-403.component';
import { Page404Component } from '@med/app/errors/components/page-404/page-404.component';
import { Page500Component } from '@med/app/errors/components/page-500/page-500.component';
import { ErrorsRoutingModule } from '@med/app/errors/errors-routing.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    ErrorsRoutingModule,
  ],
  declarations: [
    Page403Component,
    Page404Component,
    Page500Component,
  ],
})
export class ErrorsModule {
}
